import { getFunctions, httpsCallable } from 'firebase/functions';

const functions = getFunctions();

function getCallableErrorMessage(error, fallback) {
  if (!error) return fallback;
  if (error?.details?.message) return error.details.message;
  if (typeof error?.message === 'string') return error.message;
  return fallback;
}

export async function createTerminationRequest(payload) {
  try {
    const callable = httpsCallable(functions, 'createTerminationRequest');
    const result = await callable(payload);
    return result.data;
  } catch (error) {
    const message = getCallableErrorMessage(error, 'Fout bij aanmaken van opzegging');
    throw new Error(message);
  }
}

export async function updateTerminationRequest(payload) {
  try {
    const callable = httpsCallable(functions, 'updateTerminationRequest');
    const result = await callable(payload);
    return result.data;
  } catch (error) {
    const message = getCallableErrorMessage(error, 'Fout bij bijwerken van opzegging');
    throw new Error(message);
  }
}

export async function markTerminationViewed(requestId) {
  try {
    const callable = httpsCallable(functions, 'markTerminationViewed');
    const result = await callable({ requestId });
    return result.data;
  } catch (error) {
    const message = getCallableErrorMessage(error, 'Fout bij markeren als bekeken');
    throw new Error(message);
  }
}
